import React from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

const newsItems = [
  {
    id: 1,
    title: "MLB Players Trust Partnership Continues",
    date: "October 2022",
    image: "https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=800&h=500&fit=crop",
    excerpt: "We're thrilled to continue our partnership with MLB Players Trust, supporting our mission to help young professionals achieve their dreams."
  },
  {
    id: 2,
    title: "New Workshop Series: Being Successful In College",
    date: "September 2022",
    image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800&h=500&fit=crop",
    excerpt: "Join us for our latest workshop series focusing on college success strategies, study tips, and career preparation."
  },
  {
    id: 3,
    title: "500+ Cubs Mentored Milestone Reached",
    date: "August 2022",
    image: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?w=800&h=500&fit=crop",
    excerpt: "We're proud to announce that we've successfully mentored over 500 Cubs since our founding in 2019."
  },
  {
    id: 4,
    title: "Scholarship Program Expansion",
    date: "July 2022",
    image: "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800&h=500&fit=crop",
    excerpt: "Thanks to generous donors, we're expanding our scholarship program to support even more deserving students."
  },
  {
    id: 5,
    title: "Virtual Networking Event Success",
    date: "June 2022",
    image: "https://images.unsplash.com/photo-1591115765373-5207764f72e7?w=800&h=500&fit=crop",
    excerpt: "Our recent virtual networking event connected Cubs with industry leaders across multiple sectors."
  },
  {
    id: 6,
    title: "Welcome New Board Members",
    date: "May 2022",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=500&fit=crop",
    excerpt: "We're excited to welcome Vanessa Nank and Kevin Castro to our Board of Directors."
  }
];

const News = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-cyan-400 to-blue-500 text-white">
        <div className="container mx-auto px-4 text-center">
          <Calendar className="w-16 h-16 mx-auto mb-6" />
          <h1 className="text-5xl font-bold mb-6">News & Updates</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Stay up to date with the latest news, events, and success stories from Lions Unleashed.
          </p>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-20 bg-gradient-to-br from-cyan-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {newsItems.map((item) => (
              <Card key={item.id} className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:scale-105">
                <div className="relative h-48">
                  <img 
                    src={item.image} 
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute top-4 left-4 bg-white px-3 py-1 rounded-full text-xs font-semibold text-cyan-600">
                    {item.date}
                  </div>
                </div>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">{item.title}</h3>
                  <p className="text-gray-700 mb-4">{item.excerpt}</p>
                  <Button 
                    variant="ghost" 
                    className="text-cyan-600 hover:text-cyan-700 p-0 h-auto font-semibold"
                  >
                    Read More <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default News;